import { render, staticRenderFns } from "./Wildberries.vue?vue&type=template&id=3ad87f87&"
import script from "./Wildberries.vue?vue&type=script&lang=js&"
export * from "./Wildberries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports